var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 58,
    viewBox: "0 0 64 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 60,
    height: 43.3979,
    rx: 5,
    stroke: "white",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4919,
    y: 31.1836,
    width: 1.20755,
    height: 6.23656,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48.3031,
    y: 31.1836,
    width: 1.20755,
    height: 6.23656,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31.3976,
    y: 31.1836,
    width: 1.20755,
    height: 6.23656,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 31.3977,
    y: 38.4199,
    width: 1.20755,
    height: 5.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7393 38.667C15.0504 38.667 14.4919 38.1086 14.4919 37.4197H49.5108C49.5108 38.1086 48.9524 38.667 48.2635 38.667H15.7393Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67725 13.7207C9.67725 13.1684 10.125 12.7207 10.6772 12.7207H17.1489H19.5452C20.0975 12.7207 20.5452 13.1684 20.5452 13.7207V17.0863V29.1831C20.5452 29.7354 20.0975 30.1831 19.5452 30.1831H10.6772C10.125 30.1831 9.67725 29.7354 9.67725 29.1831V13.7207Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7145 16.8652L18.4963 16.8652",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7145 21.084L18.4963 21.084",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7145 25.3008L18.4963 25.3008",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4888 13.7207C43.4888 13.1684 43.9365 12.7207 44.4888 12.7207H50.9605H53.3567C53.909 12.7207 54.3567 13.1684 54.3567 13.7207V17.0863V29.1831C54.3567 29.7354 53.909 30.1831 53.3567 30.1831H44.4888C43.9365 30.1831 43.4888 29.7354 43.4888 29.1831V13.7207Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5259 16.8652L52.3077 16.8652",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5259 21.084L52.3077 21.084",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5259 25.3008L52.3077 25.3008",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.583 13.7207C26.583 13.1684 27.0307 12.7207 27.583 12.7207H34.0547H36.4509C37.0032 12.7207 37.4509 13.1684 37.4509 13.7207V17.0863V29.1831C37.4509 29.7354 37.0032 30.1831 36.4509 30.1831H27.583C27.0307 30.1831 26.583 29.7354 26.583 29.1831V13.7207Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6201 16.8652L35.4019 16.8652",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6201 21.084L35.4019 21.084",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6201 25.3008L35.4019 25.3008",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0942 56.5059C15.0942 55.9536 15.542 55.5059 16.0942 55.5059H47.9056C48.4578 55.5059 48.9056 55.9536 48.9056 56.5059V58.0005H15.0942V56.5059Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7528 49.9906C25.8768 49.5634 26.2682 49.2695 26.7131 49.2695H37.2868C37.7316 49.2695 38.123 49.5634 38.2471 49.9906L39.849 55.5061H24.1509L25.7528 49.9906Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationIcon);
export default __webpack_public_path__ + "static/media/operationIcon.9ea14c78740c360c9e2d008590c4db55.svg";
export { ForwardRef as ReactComponent };